import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import eczodexLogo from "../../assets/icons/eczodex-main-logo.svg";
import emailLogo from "../../assets/icons/email.svg";
import instaLogo from "../../assets/icons/ig.svg";
import xLogo from "../../assets/icons/x.svg";
import { eczodexAppUrl } from "../../lib/constants";

const styles = {
  footer: `w-full h-fit min-h-[18.4rem] bg-[#FFF] gap-y-[2.5rem] flex items-center justify-center p-[1.25rem] lg:px-[10rem] lg:py-[3.8rem]`,
  logoCtn: `w-[9.3rem] h-[2.3rem]`,
  copyrightCtn: `text-[#82849E] text-base lg:text-[1.125rem] font-normal`,
  copyrightCtnSec: `text-[#5EBC8B] text-base lg:text-[1.125rem] font-normal`,
};

interface IProps {
  scrollToSection: (urlFragment: string) => void;
}

const Footer = ({ scrollToSection }: IProps) => {
  const location = useLocation();
  const { pathname } = location;
  const [currentRoute, setCurrentRoute] = useState("");

  useEffect(() => {
    if (pathname === "/") {
      setCurrentRoute("landing");
    } else if (pathname === "/contact-us") {
      setCurrentRoute("contact-us");
    }
  }, [pathname]);

  return (
    <div className={styles.footer}>
      <div className="w-fit flex flex-col items-center justify-center gap-[1rem] lg:gap-[2.5rem]">
        <img
          src={eczodexLogo}
          alt="main-logo"
          width={150}
          height={36}
          className={styles.logoCtn}
        />
        <div className="flex items-center justify-center gap-[1rem]">
               <Link to="https://eczodex-privacy-policy-e0hjgcc8cbanbyfe.eastus-01.azurewebsites.net" target="_blank" rel="noopener noreferrer">
          <div className={styles.copyrightCtnSec}>Privacy Policy</div>
        </Link>
        <Link to="https://eczodex-terms-service-aqfzeta9hvgqfghv.eastus-01.azurewebsites.net" target="_blank" rel="noopener noreferrer">
          <div className={styles.copyrightCtnSec}>Terms of Service</div>
        </Link>
        </div>
        <div className={styles.copyrightCtn}>Ⓒ All rights reserved 2026</div>

      </div>
    </div>
  );
};

export default Footer;
